<div class="container" (scroll)="onScroll()" #contentDiv>
  <div class="content-div">
    <div class="panel left-panel">
      <img 
        src="/assets/images/biq/left-panel.svg" 
        alt="left-panel" 
        class="panel-img left-img"
      />
    </div>
    <div class="info-div">
      @if (showFullname) {
        <app-biq-fullname (continueEmitter)="onNameContinue()"></app-biq-fullname>
      } @else if (showLocation) {
        <app-biq-location (continueEmitter)="onLocationContinue()"></app-biq-location>
      } @else if (showDOB) {
        <app-biq-birth-date (continueEmitter)="onDOBContinue()"></app-biq-birth-date>
      } @else if (showGender) {
        <app-biq-gender (continueEmitter)="onGenderContinue()"></app-biq-gender>
      } @else if (showEthnicity) {
        <app-biq-ethnicity (continueEmitter)="onEthnicityContinue()"></app-biq-ethnicity>
      } @else if (showEmployment) {
        <app-biq-employment (continueEmitter)="onEmploymentContinue()"></app-biq-employment>
      } @else if (showDesiredLocation) {
        <app-biq-desired-location (continueEmitter)="onDesiredLocContinue()">
        </app-biq-desired-location>
      } @else if (showEndPage) {
        <app-biq-end-page (continueEmitter)="onEndPageContinue()"></app-biq-end-page>
      } @else {
        <app-biq-start-page (startEmitter)="onClickGetStartedBtn()"></app-biq-start-page>
      }
    </div>
    <div class="panel right-panel">
      <img 
        src="/assets/images/biq/right-panel.svg" 
        alt="left-panel" 
        class="panel-img right-img"
      />
    </div>
  </div>
</div>